import React, { useContext, useCallback } from 'react';
import { FormSpy } from 'react-final-form';
import FundInvestorSummary from '../FundInvestorSummary';
import { ManageContactContext } from './ManageContactContext';
import CustomSimpleForm from '../../../core/components/form/CustomSimpleForm';

const ManageStep = props => {
  const { investorId, fundId, onSubmitEnd } = props;
  const { contactsContext, setContactsContext } = useContext(
    ManageContactContext
  );

  const setFundInvestors = useCallback(
    values => {
      setContactsContext({
        ...contactsContext,
        currentForm: undefined,
        funds: values.funds,
        investors: values.investors
      });
      onSubmitEnd(values);
    },
    [contactsContext, onSubmitEnd, setContactsContext]
  );

  return (
    <CustomSimpleForm
      save={setFundInvestors}
      initialValues={{
        funds: contactsContext.funds || [],
        investors: contactsContext.investors || []
      }}
      toolbar={null}
      // We override the redux-form name to avoid collision with the react-admin main form
      resource="fundinvestors"
      variant="standard"
      margin="normal"
    >
      <FormSpy>
        {formprops => {
          if (contactsContext.currentForm === undefined) {
            setContactsContext({
              ...contactsContext,
              currentForm: formprops.form
            });
          }

          return (
            <FundInvestorSummary
              {...props}
              creation
              investorId={investorId}
              fundId={fundId}
            />
          );
        }}
      </FormSpy>
    </CustomSimpleForm>
  );
};

export default ManageStep;
